<template>
  <div class="base-data-table">
    <a-table
      :columns="normalizedColumns"
      :data-source="items"
      :row-key="rowKey"
      :row-selection="rowSelection"
      :pagination="paginationConfig"
      :loading="loading"
      :scroll="scroll"
      @change="onChange"
    />
  </div>
</template>

<script>
export default {
  name: "BaseDataTable",
  props: {
    columns: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    rowKey: {
      type: String,
      default: "id",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default: null,
    },
    scroll: {
      type: Object,
      default: undefined,
    },
    pageSizeOptions: {
      type: Array,
      default: () => ["10", "20", "30", "50", "100"],
    },
    showSizeChanger: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selectedRowKeys: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    normalizedColumns() {
      const vm = this;

      return this.columns.map(function (column) {
        const slotName = column.scopedSlots && column.scopedSlots.customRender;
        if (!slotName) return column;

        const normalized = { ...column };
        delete normalized.scopedSlots;
        normalized.customRender = function (text, record, index, col) {
          const slot = vm.$scopedSlots[slotName];
          return slot ? slot(text, record, index, col) : text;
        };

        return normalized;
      });
    },
    rowSelection() {
      if (!this.selectable) return null;

      return {
        selectedRowKeys: this.selectedRowKeys,
        columnWidth: 48,
        onChange: (selectedKeys) => {
          this.$emit("selection-change", selectedKeys);
        },
      };
    },
    paginationConfig() {
      if (!this.pagination) return false;

      return {
        current: this.pagination.current,
        pageSize: this.pagination.perPage,
        total: this.pagination.total,
        showSizeChanger: this.showSizeChanger,
        pageSizeOptions: this.pageSizeOptions,
        showTotal: (total, range) =>
          `Exibindo ${range[0]}-${range[1]} de ${total} registros`,
        locale: { items_per_page: "/ página" },
      };
    },
  },
  methods: {
    onChange(pagination, filters, sorter) {
      this.$emit("change", {
        page: pagination && pagination.current,
        perPage: pagination && pagination.pageSize,
        sorter: this.buildSorter(sorter),
      });
    },
    buildSorter(sorter) {
      if (!sorter || !sorter.order) return null;

      return {
        field: sorter.columnKey,
        direction: sorter.order === "ascend" ? "asc" : "desc",
      };
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.base-data-table {
  /deep/ .ant-pagination-item-active {
    border-color: @color-primary;

    a {
      color: @color-primary;
    }
  }
}
</style>
